import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 5 — Learning (LMS) shell. Sidebar nav + <Outlet/>, reusing the
 * `hr-shell` layout/CSS (mirrors TalentShell). Additive learning layer.
 */

const NAV = [
  { to: '/learning/catalog', label: 'Course Catalog', testid: 'learning-nav-catalog' },
  { to: '/learning/paths', label: 'Learning Paths', testid: 'learning-nav-paths' },
  { to: '/learning/my-learning', label: 'My Learning', testid: 'learning-nav-mylearning' },
  { to: '/learning/certifications', label: 'Certifications', testid: 'learning-nav-certifications' },
  { to: '/learning/compliance', label: 'Compliance', testid: 'learning-nav-compliance' },
];

export default function LearningShell() {
  return (
    <div className="hr-shell" data-testid="learning-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Learning</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
